import { UIHeading1 } from '@cian/ui-kit';
import { FC } from 'react';
import { clsx } from 'clsx';

import { ApplicationDownloadButtonContainer } from 'shared/containers/ApplicationDownloadButtonContainer';
import { TPlatform } from 'shared/types/platform';

import * as style from './style.css';

interface IMotivationMobileProps {
  platform: TPlatform;
  isBottom?: boolean;
  onClick: (buttonName: string) => void;
}

export const MotivationMobile: FC<IMotivationMobileProps> = ({ platform, isBottom, onClick }) => {
  return (
    <div className={clsx(style['container'], isBottom && style['container-bottom'])}>
      <div className={clsx(style['wrapper'], isBottom && style['wrapper-bottom'])}>
        <div className={style['title']}>
          <UIHeading1>
            {' '}
            В приложении&nbsp;—
            <br />
            быстрее и&nbsp;удобнее!
          </UIHeading1>
        </div>
        <div className={clsx(isBottom ? style['content-bottom'] : style['content'])}>
          <div className={clsx(style['phone'], isBottom && style['phone-bottom'])}></div>
        </div>
        <div className={style['button']}>
          <ApplicationDownloadButtonContainer
            platform={platform}
            onClick={() => onClick(isBottom ? 'footer_download_app' : 'header_download_app')}
          />
        </div>
      </div>
    </div>
  );
};
